<template>
    <div class="main-container">
        <div class="main-container-title-box">
            <div class="main-container-title-box-text">
                <span class="title-box-text">
                    Рассылка
                </span>
                <!-- <v-icon  color="var(--app-dark-blue-1)">mdi-information</v-icon> -->
                <!-- <v-icon  @mouseover="openInfo($event)" @mouseleave="showInfo = false" color="var(--app-dark-blue-1)">mdi-information</v-icon> -->
            </div>

            <v-menu v-model="showInfo" :position-x="x" :position-y="y" absolute offset-y>
                <v-card min-width="300px" min-height="100px">
                    <div class="menu-container">
                        <div class="menu-container-title">
                            «Список новостей»
                        </div>
                        <div class="menu-container-text">
                            Основной список отображающийся во вкладке меню мобильного приложения "Новости"
                        </div>
                        <div class="menu-container-title">
                            Иконка
                            <v-icon small color="#929292">
                                mdi-eye-off
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            Если эта иконка показывается – значит эта новость скрыта
                        </div>
                        <div class="menu-container-title">
                            Иконка
                            <v-icon small color="#929292">
                                mdi-star
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            Вместо порядкового номера - звездочка - значит это главная новость. Главная новость отображается
                            всегда первой в списке с большим изображением.
                        </div>
                        <div class="menu-container-title">
                            Иконка
                            <v-icon small color="#929292">
                                mdi-bell
                            </v-icon>
                        </div>
                        <div class="menu-container-text">
                            При отображении колокольчика около даты - отправиться/отправлялось push-уведомление при
                            публикации новости
                        </div>
                    </div>

                </v-card>
            </v-menu>

        </div>
        <div class="table-container">

            <v-data-table :footer-props="{ itemsPerPageOptions: [10, 25, 50], 'items-per-page-text': '' }"
                :headers="tableHeaders" :items="events" class="elevation-0 main-table"
                :items-per-page="optionTable.itemsPerPage" :page="optionTable.page" hide-default-header
                :server-items-length="optionTable.serverItemsLength" @pagination="tableChange" ref="sortableTable"
                fixed-header>
                <template v-slot:header>
                    <thead>
                        <tr>
                            <th v-for="(s, index ) in tableHeaders" :key="index">
                                <div>
                                    {{ s.text }}
                                </div>

                            </th>
                        </tr>
                    </thead>
                </template>
                <template slot="body">
                    <tbody>
                        <tr v-for="(item, index) in events" :key="index" @click="goToDetail(item)" style="  height: auto;">
                            <td>
                                {{ item.name }}
                            </td>
                            <td>
                                {{ item.place || "" }}
                            </td>

                            <td>
                                <span v-if="item.hideEventTime">
                                    {{ item.plannedDate | moment("DD.MM.YYYY") }}
                                </span>
                                <span v-else>
                                    {{ item.plannedDate | moment("DD.MM.YYYY HH:mm") }}
                                </span>
                            </td>

                            <td>
                                {{ item.datePublish | moment("DD.MM.YYYY HH:mm") }}
                            </td>
                        </tr>

                    </tbody>

                </template>
            </v-data-table>


        </div>
        <v-divider></v-divider>
    </div>
</template>
<script>


export default {

    data: () => ({
        showInfo: false,
        x: null,
        y: null,
        events: [],
        sortedNumbers: [],
        optionTable: {
            page: 1,
            itemsPerPage: 10,
            serverItemsLength: -1
        },
        tableHeaders: [

            {
                text: 'Заголовок',
                sortable: false,
                value: 'name',
            },

            {
                text: 'Место',
                sortable: false,
                value: 'place',
            },
            {
                text: 'Дата события',
                sortable: false,
                value: 'plannedDate',
            },
            {
                text: 'Дата публикации',
                sortable: false,
                value: 'datePublish',
            },

        ],
    }),
    methods: {
        checkLocal() {
            const localOptionTable = JSON.parse(localStorage.getItem("eventsOptionTable"))
            if (localOptionTable) {
                this.optionTable = localOptionTable
            }

        },
        openInfo(e) {

            e.preventDefault()

            this.x = e.clientX + 10
            this.y = e.clientY + 10
            this.showInfo = true
        },

        goToDetail(item) {
            this.$router.push({ name: 'LettersEvent', params: { id: item.id } })

        },
        getEvents() {
            this.$axios.post(this.$store.getters.apiAdminPanelV2 + '/event/list', {
                optionTable: this.optionTable,

            }, {
                headers: {
                    'authorization': this.$store.getters.adminPanelHeaderAuth
                }
            })
                .then(res => {
                    this.optionTable = res.data.optionTable;
                    this.events = res.data.items
                    const numberOnly = this.events.map(item => {
                        return item.index
                    })
                    this.sortedNumbers = numberOnly.sort((a, b) => {
                        return a - b;
                    })

                })
                .catch(err => {
                    this.$store.commit('errorSet', true)
                    this.$store.commit('errorTextSet', err)
                })

        },
        tableChange(data) {

            this.optionTable.page = data.page
            this.optionTable.itemsPerPage = data.itemsPerPage
            localStorage.setItem('eventsOptionTable', JSON.stringify(this.optionTable))
            this.getEvents()
        },

    },
    created() {
        this.checkLocal()
        this.getEvents()
    },
}
</script>
<style lang="scss" scoped>
.table-container {
    height: calc(100vh - 190px);

    .main-table {
        height: calc(100vh - 190px) !important;
        min-height: calc(100vh - 190px) !important;
        max-height: calc(100vh - 190px) !important;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

    }
}
</style>
